var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Channel.Type === 'Services')?_c('Services'):_c('Query')}
var staticRenderFns = []

export { render, staticRenderFns }